import React, { PureComponent } from 'react'

import { STORAGE_KEY } from '@/lib/constants'

import Seeker from '@/assets/onboarding/seeker.svg'
import Interviewer from '@/assets/onboarding/interviewer.svg'
import Recruiter from '@/assets/onboarding/recruiter.svg'
import Student from '@/assets/onboarding/student.svg'
import Selected from '@/assets/iconography/selected.svg'
import Unselected from '@/assets/iconography/unselected.svg'

export default class Onboarding02About extends PureComponent {
  state = {
    error: null,
    status: null,
    continueEnabled: false,
  }
  componentDidMount = async () => {
    if(this.props.user && this.props.user.about && this.props.user.about.status) {
      this.setState({
        status: this.props.user.about.status,
        continueEnabled: true,
      })
    }
  }
  setStatus = (status) => {
    this.setState({
      status,
      continueEnabled: true,
    })
  }
  continue = async () => {
    this.setState({
      error: null
    })
    const DEMO_TOKEN = await localStorage.getItem(STORAGE_KEY)
    const res = await fetch(`/api/users/onboarding/about`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Headers': 'Origin',
        'Authorization': 'Bearer ' + DEMO_TOKEN,
        'x-access-token': DEMO_TOKEN
      },
      body: JSON.stringify({
        status: this.state.status
      })
    })
    const { auth, error } = await res.json()
    if (auth) {
      await this.props.checkProgress()
    } else {
      this.setState({
        error
      })
    }
  }
  render() {
    return (
      <div className = 'column align-items-center'>
        <div className = 'column text-align-center margin-bottom'>
          <h1 className = 'no-margin'>What best describes you?</h1>
          <h3 className = 'thin'>We'll tailor your experience accordingly.</h3>
        </div>
        <div className = 'column align-items-center'>
          <div className = 'onboarding-selector-container'>
            <div className = {this.state.status === 'seeker' ? 'onboarding-selector-card' : 'onboarding-selector-card unselected'} onClick = {() => this.setStatus(`seeker`)}>
              <img
                src = {this.state.status === 'seeker' ? Selected : Unselected}
                alt = 'Daily Product Prep selector'
                className = 'selector'
              />
              <div className = 'text'>
                <img
                  src = {Seeker}
                  alt = 'Daily Product Prep job seeker product manager'
                  className = 'onboarding-card-splash'
                />
                <p className = 'title'>Job seeker</p>
                <p className = 'subtitle'>Get the best content to help you prepare for interviews.</p>
              </div>
            </div>
            <div className = {this.state.status === 'interviewer' ? 'onboarding-selector-card' : 'onboarding-selector-card unselected'} onClick = {() => this.setStatus(`interviewer`)}>
              <img
                src = {this.state.status === 'interviewer' ? Selected : Unselected}
                alt = 'Daily Product Prep selector'
                className = 'selector'
              />
              <div className = 'text'>
                <img
                  src = {Interviewer}
                  alt = 'Daily Product Prep product manager interviewer'
                  className = 'onboarding-card-splash'
                />
                <p className = 'title'>Interviewer</p>
                <p className = 'subtitle'>Get recommended questions and interview guides.</p>
              </div>
            </div>
            <div className = {this.state.status === 'recruiter' ? 'onboarding-selector-card' : 'onboarding-selector-card unselected'} onClick = {() => this.setStatus(`recruiter`)}>
              <img
                src = {this.state.status === 'recruiter' ? Selected : Unselected}
                alt = 'Daily Product Prep selector'
                className = 'selector'
              />
              <div className = 'text'>
                <img
                  src = {Recruiter}
                  alt = 'Daily Product Prep product manager recruiter'
                  className = 'onboarding-card-splash'
                />
                <p className = 'title'>Recruiter</p>
                <p className = 'subtitle'>Post jobs, receive referrals, and screen top candidates.</p>
              </div>
            </div>
            <div className = {this.state.status === 'student' ? 'onboarding-selector-card' : 'onboarding-selector-card unselected'} onClick = {() => this.setStatus(`student`)}>
              <img
                src = {this.state.status === 'student' ? Selected : Unselected}
                alt = 'Daily Product Prep selector'
                className = 'selector'
              />
              <div className = 'text'>
                <img
                  src = {Student}
                  alt = 'Daily Product Prep product manager student'
                  className = 'onboarding-card-splash'
                />
                <p className = 'title'>Student</p>
                <p className = 'subtitle'>Learn about product or level up your current skills.</p>
              </div>
            </div>
          </div>
          <div className = 'onboarding-continue focusable column'>
            <span className = 'error-text'>{this.state.error}</span>
            {
              this.state.continueEnabled ?
              <button onClick = {() => this.continue()}>Continue</button>
              : <button className = 'disabled-button' disabled>Continue</button>
            }
          </div>
        </div>
      </div>
    )
  }
}
